const mutations = {
    setPurchaseList(state, data) {
      state.purchaseList = data;
    },
    setPurchase(state, data) {
      state.purchase = data;
    },
    resetPurchase(state) {
      state.purchase = {
        date: new Date().toISOString(),
          supplier_id: "",
          invoice_number: "",
          status: "",
          payment_mode_id: "",
          payment_note: "",
          total: 0,
          paid_amount: 0,
          items: [
              {
                  product_id: "",
                  quantity: 1,
                  price: 0,
                  tax_id: "",
                  discount: 0
              }
          ]
      };
  },
  setDefaultPaymentMode(state, data) {
    state.purchase.payment_mode_id = data; 
    state.defaultPaymentModeId = data;
  },
    setSuppliers(state, suppliers) {
      state.suppliers = suppliers;
    }
   
  };
  
  export default mutations;
  